export default "__VITE_ASSET__2QvRHNEE__"